export const FILE_MAX_SELECTION = 2000;
